
    import Vue from 'vue';
    //import {createSimpleTransition} from 'vuetify/src/util/helpers';
    import vuex from '../../store';
    import {mapMutations, mapState} from 'vuex';
    import moment from "moment";
    // Components
    import RomaUnit from './RomaUnit.vue';
    import RomaAnualPlanPanel from './RomaAnualPlanPanel.vue';
    import RomaUnitModalForm from './RomaUnitModalForm.vue';
    import RomaExcelModalForm from './RomaExcelModalForm.vue';
    import RomaConfirmDialog from '../commons/RomaConfirmDialog.vue';
    import RomaPercentage from "../commons/RomaPercentage.vue";
    import RomaReportFiltersModal from "./RomaReportFiltersModal.vue";
    // Reports
    import {AnualCoverageReport} from '@/reports/AnualCoverageReport';
    // Store
    import UnitPlan from "@/store/units/UnitPlan";
    import UnitPlanAttitude from '@/store/planner/purpose/UnitPlanAttitude';
    import UnitPlanPreLearning from '@/store/planner/purpose/UnitPlanPreLearning';
    import UnitPlanSkill from '@/store/planner/purpose/UnitPlanSkill';
    import UnitPlanComments from '@/store/units/UnitPlanComments';
    // Interface
    import {Collection} from '@vuex-orm/core';
    import {IUnitPlan} from "@/interfaces/units/IUnitPlan";
    import {IUnitPlanAttitude} from "@/interfaces/planner/purpose/IUnitPlanAttitude";
    import {IUnitPlanPreLearning} from "@/interfaces/planner/purpose/IUnitPlanPreLearning";
    import {IUnitPlanSkill} from "@/interfaces/planner/purpose/IUnitPlanSkill";

    //const romaUnitListTransition = createSimpleTransition('unit-list-transition');

    //Vue.component('my-transition', romaUnitListTransition);

    export default Vue.extend({
        name: 'RomaUnitList',
        async created(): void {
            this.unsubscribe = this.$store.subscribe((mutation, state) => {                           
                if(mutation.type == 'planAnualList'){
                    //console.log(state.planAnualList);
                    this.anualPlansList = state.planAnualList;
                }                
            })
            this.page = this.selectedPage;
            await this.$store.dispatch('roma', {});
            if (this.firstLoadOfUnitPlanList) {
                this.appLoading(false);
            }
            //this.getAnualPlansByPage(1);
            //this.getUnitPlansByPage(1);
        },
        beforeDestroy(){      
            this.unsubscribe();
        },
        props: {
            school: {
                type: Object,
                required: true,
            },
            firstSearch: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                unsubscribe: null,
                anualPlansList: [],
                reportType: '',
                filterByEducation: false,
                seeCoverageByCourses: false,
                showReportModalFilters: false,
                modalTittle: '',
                modalAction: '',
                userPrivileges: this.$store.state.user.privileges,
                firstLoadOfUnitPlanList: false,
                firstLoadOfAnualPlanList: false,
                page: 1,
                lastPage: 1,
                itemsPerPage: 10,
                dialogDeleteUnit: false,
                selectedUnit: null,
                selectedUnitForReports: {
                    id: null,
                    id_plan: null,
                },
                showUnitModalForm: false,
                showExcelModalForm: false,
                menuReports: [
                    {
                        label: this.$vuetify.lang.t('$vuetify.component.romaUnitList.unitPlan'),
                        enable: true,
                        onClick: (unit: any) => {
                            this.selectedUnitForReports = {
                                id: unit.id,
                                id_plan: null,
                            };
                            this.showReportModalFilters = true;
                            this.filterByEducation = false;
                            this.reportType = null;
                        },
                    },
                    {
                        label: this.$vuetify.lang.t('$vuetify.component.romaUnitList.annualPlan'),
                        enable: true,
                        onClick: (unit: any) => {
                            this.selectedUnitForReports = {
                                id: null,
                                id_plan: unit.id_plan,
                            };
                            this.showReportModalFilters = true;
                            this.filterByEducation = false;
                            this.reportType = null;
                        },
                    },
                    {
                        label: this.$vuetify.lang.t('$vuetify.component.romaUnitList.annualCoverage'),
                        enable: this.$store.state.user.privileges.canSeeReportAnual,
                        onClick: async (unit: any) => {
                            this.appLoading();
                            const params: URLSearchParams = new URLSearchParams(
                                `plan_id=${unit.id_plan}&unitPlan_id=-1&general=false&activities=false&cronogram=false&reportType=ANUAL_COVERAGE`
                            );

                            let msj = {
                                show: true,
                                text: '',
                                color: 'red',
                            };

                            const response: any = await this.$store.dispatch('getReport', { params });

                            if (!(response.data && response.data.status && response.data.status.code === 1)) {
                                msj.show = true;
                                if (response.data && response.data.status && response.data.status.code === 3) {
                                    msj.text = response.data.content.message;
                                    msj.color = "red";
                                } else {
                                    msj.text = "No se pudo generar el reporte";
                                    msj.color = "red";
                                }
                            } else {
                                const anualCoverageReport: AnualCoverageReport = new AnualCoverageReport(this.user, this.$store.state.organizer.selectedSchool, { idPlan: unit.id_plan , emissionDate: moment().format('DD/MM/YYYY  h:mm A'), ...response.data.content} , this.$store.state.logoURL);
                                try {
                                    msj.text = await anualCoverageReport.downloadReport();
                                    msj.color = 'success';
                                } catch (error) {
                                    console.error("Error al generar reporte de cobertura anual", error);
                                    msj.text = error;
                                }
                            }
                            this.$store.state.snackbar = msj;
                            this.appLoading(false);
                        },
                    },
                ]
            };
        },
        computed: {
            isUTP () {
                let opt = false;
                if (this.$store.state.user.role === 'utp') opt = true;
                return opt;
            },
            fullButtons () {
                return !this.isUTP ? 6 : 10;
            },
            selectedPage: {
                get () {
                    return this.page;
                },
                set (value) {
                    this.page = value;
                    //this.$store.state.unitList.paginator.page = value;
                }
            },
            /*
            lastPage () {
                return this.$store.state.unitList.paginator.lastPage;
            },*/
            getUnitPlans(): Collection<IUnitPlan> {
                let result: Collection<IUnitPlan>;
                if (this.user.institution.type.sostenedor) {
                    result = UnitPlan.query()
                        .orderBy('asignatura')
                        .orderBy('educationLevel')
                        .orderBy('level')
                        .orderBy('course')
                        .orderBy('name1')
                        .withAll()
                        .get();
                } else {
                    result = UnitPlan.query()
                        .where('school_id', this.school.id)
                        .orderBy('asignatura')
                        .orderBy('educationLevel')
                        .orderBy('level')
                        .orderBy('course')
                        .orderBy('name1')
                        .withAll()
                        .get();
                }

                return result;
            },
            ...mapState([
                'roma',
                'user',
            ]),
        },
        watch: {
            page: {
                immediate: true,
                handler(value) {
                    //this.$store.state.unitList.paginator.page = this.$store.state.unitList.paginator.page > 0 ? this.$store.state.unitList.paginator.page : value;
                    //this.getUnitPlansByPage(this.$store.state.unitList.paginator.page);
                    if(this.firstSearch){
                        this.getAnualPlansByPage(value);
                    }
                }
            },
        },
        methods: {
            generateReport(event){

                if(event.reportType == 1){
                    //Unit plan report
                    this.generateUnitPlanReport(event.data);
                }else if(event.reportType == 2){
                    //Anual plan report
                    this.generateAnualPlanReport(event.data);
                }else if(event.reportType == 3){
                    //Anual coverage report
                    this.generateAnualCoverageReport(event.data);
                }
            },
            generateUnitPlanReport(unit: any) {
                this.selectedUnitForReports = {
                    id: unit.id,
                    id_plan: null,
                };
                this.showReportModalFilters = true;
                this.filterByEducation = false;
                this.reportType = null;
            },
            generateAnualPlanReport(anualPlan: any) {
                this.selectedUnitForReports = {
                    id: null,
                    id_plan: anualPlan.id_plan_anual,
                };
                this.showReportModalFilters = true;
                this.filterByEducation = false;
                this.reportType = null;
            },
            async generateAnualCoverageReport(anualPlan: any){
                this.appLoading();
                const params: URLSearchParams = new URLSearchParams(
                    `plan_id=${anualPlan.id_plan_anual}&unitPlan_id=-1&general=false&activities=false&cronogram=false&reportType=ANUAL_COVERAGE`
                );

                let msj = {
                    show: true,
                    text: '',
                    color: 'red',
                };

                const response: any = await this.$store.dispatch('getReport', { params });
                if (!(response.data && response.data.status && response.data.status.code === 1)) {
                    msj.show = true;
                    if (response.data && response.data.status && response.data.status.code === 3) {
                        msj.text = response.data.content.message;
                        msj.color = "red";
                    } else {
                        msj.text = "No se pudo generar el reporte";
                        msj.color = "red";
                    }
                } else {
                    const anualCoverageReport: AnualCoverageReport = new AnualCoverageReport(this.user, this.$store.state.organizer.selectedSchool, response.data.content, this.$store.state.logoURL);
                    try {
                        msj.text = await anualCoverageReport.downloadReport();
                        msj.color = 'success';
                    } catch (error) {
                        console.error("Error al generar reporte de cobertura anual", error);
                        msj.text = error;
                    }
                }
                this.$store.state.snackbar = msj;
                this.appLoading(false);
            },
            showCoverageBy(reportType: string) {
                this.filterByEducation = true;
                this.showReportModalFilters = true;
                this.reportType = reportType;
            },
            canRegisterAdvance(unit: any): boolean {
                return unit.hasCoverage
                    && (
                        (unit.editing_status_id === 1 && !this.user.institution.type.hasApprobationFlux)
                        ||
                        (unit.editing_status_id === 3 && this.user.institution.type.hasApprobationFlux)
                        ||
                        (unit.plan_status_id === 1)
                    );
            },
            ...mapMutations(['appLoading', 'planAnualList']),
            loadingEvent(loading: any){
                if(loading){
                    this.appLoading();
                }else{
                    this.appLoading(false);
                }
            },
            refreshAnualPlans(loading: any){
                if(loading){
                    this.getAnualPlansByPage(this.selectedPage);
                }
            },
            async setStatus(unit: any, commands: any) {
                this.appLoading();
                const msj = {
                    show: true,
                    text: '',
                    color: 'success',
                };
                const request = {
                    idPlanUnidad: unit.id,
                    commands,
                };
                await this.$store.dispatch('setUnitPlanStatus', request)
                    .then(async (response) => {
                        if (response.data && response.data.status && response.data.status.code === 1) {
                            msj.text = response.data.content;
                            await this.getUnitPlansByPage(this.$store.state.unitList.paginator.page);
                        } else if (response.data && response.data.status && response.data.status.code === 3) {
                            msj.text = response.data.content.message;
                            msj.color = 'red';
                        } else {
                            msj.text = 'No se pudo cerrar la edición';
                            msj.show = false;
                        }
                        this.$store.state.snackbar = msj;
                        return;
                    })
                    .catch((error) => {
                        this.$store.state.snackbar = msj;
                    });
                this.appLoading(false);
            },
            addUnit() {
                this.modalTittle = 'Agregar Plan Unidad';
                this.modalAction = 'Add';
                this.selectedUnit = null;
                this.showUnitModalForm = true;
            },
            editUnit(unit) {
                this.modalTittle = 'Editar Plan Unidad';
                this.modalAction = 'Edit';
                this.selectedUnit = unit;
                this.showUnitModalForm = true;
            },
            duplicateUnit(unit) {
                this.modalTittle = 'Duplicar Plan Unidad';
                this.modalAction = 'Duplicate';
                this.selectedUnit = unit;
                this.showUnitModalForm = true;
            },
            goDelUnit(unit: object) {
                this.dialogDeleteUnit = true;
                this.selectUnit(unit);
            },
            async delUnit() {
                this.appLoading();
                let msj = {
                    show: true,
                    text: '',
                    color: 'success',
                };
                const response = await this.$store.dispatch('deletePlanUnit', this.selectedUnit.id);

                if (response.data && response.data.status && response.data.status.code === 1) {
                    msj.text = 'Se ha borrado el plan unidad';
                    await this.$store.dispatch('roma', {});
                    UnitPlan.delete(this.selectedUnit.id);
                    UnitPlanAttitude.delete((detail: IUnitPlanAttitude) => detail.unitplan_id === this.selectedUnit.id); // Actitudes
                    UnitPlanPreLearning.delete((detail: IUnitPlanPreLearning) => detail.unitplan_id === this.selectedUnit.id);
                    UnitPlanSkill.delete((detail: IUnitPlanSkill) => detail.unitplan_id === this.selectedUnit.id);
                } else if (response.data && response.data.status && response.data.status.code === 3) {
                    msj.text = response.data.content.message;
                    msj.color = 'red';
                } else {
                    msj.text = 'Planificación no pudo ser borrada';
                    msj.color = 'red';
                }
                this.dialogDeleteUnit = false;
                this.$store.state.snackbar = msj;
                this.appLoading(false);
            },
            selectUnit(unit) {
                this.selectedUnit = unit;
            },
            async getUnitPlansByPage(page: number) {
                const filter = this.$store.state.unitList.paginator.filter;
                const params = `idInstitucion=${filter.institution}&idPlanAnual=${filter.plan}&idAsignatura=${filter.subject}&idCategoria=${filter.level}&courseName=${filter.courseName}&idUnidad=${filter.unit}&idEstadoEdicion=${filter.editionStatus}&idEstadoPlan=${filter.planStatus}&idPersona=${filter.teacher}&porcentajeAvanceCurricular=${filter.percentage}&page=${page}&itemsPerPage=${this.itemsPerPage}&isActive=${filter.isActive}&pie=${filter.pie}&puName=${filter.puName}&year=${filter.years}`;
                const request = new URLSearchParams(params);
                this.appLoading();
                return await vuex.dispatch('getUnitPlans', request).then(data => {
                    // Paginador
                    this.$store.state.unitList.paginator.lastPage = data.data.content.lastPage;

                    UnitPlan.deleteAll();
                    // Proposito
                    UnitPlanPreLearning.deleteAll();
                    UnitPlanSkill.deleteAll();
                    UnitPlanAttitude.deleteAll();
                    // Comentarios
                    UnitPlanComments.deleteAll();

                    if (data.data.content.data.length > 0) {
                        data.data.content.data.forEach(uniplan => {
                            // Educación para poder ordenar por educación media y básica
                            uniplan.educationLevel = uniplan.nivel.substring(uniplan.nivel.lastIndexOf('°') + 1).trim();
                            // Campos de nivel y sección por separado
                            uniplan.level = uniplan.nivel;
                            uniplan.course = uniplan.seccion;
                            UnitPlan.insertOrUpdate({data: uniplan});
                        });
                    } else {
                        this.selectedPage = 1;
                    }
                    /*
                    if (Object.entries(this.roma).length > 0 || !this.userPrivileges.canCudPlanAndClose) {
                        this.appLoading(false);
                    }*/
                    this.appLoading(false);
                    this.firstLoadOfUnitPlanList = true;
                }).catch(errors => {
                    this.appLoading(false);
                });
            },
            async getAnualPlansByPage(page: number) {
                const filter = this.$store.state.unitList.paginator.filter;
                this.selectedPage = page;
                const params = `idInstitucion=${filter.institution}&idAsignatura=${filter.subject}&idCategoria=${filter.level}&idSeccion=${filter.course}&idPersona=${filter.teacher}&year=${filter.years}&page=${page}&itemsPerPage=${this.itemsPerPage}`;
                const request = new URLSearchParams(params);
                this.appLoading();
                try{
                    await vuex.dispatch('getAnualPlans', request).then(res => {
                        this.anualPlansList = res.data.content.data;
                        
                        this.lastPage = res.data.content.lastPage;
                        this.firstLoadOfAnualPlanList = true;
                        this.appLoading(false);
                        this.planAnualList(res.data.content.data);
                        if(res.data.content.length == 0){
                            this.selectedPage = 1;
                        }
                    });
                }catch(e){
                    this.appLoading(false);
                }
            }

        },
        components: {
            RomaUnit,
            RomaConfirmDialog,
            RomaUnitModalForm,
            RomaExcelModalForm,
            RomaPercentage,
            RomaReportFiltersModal,
            RomaAnualPlanPanel
        },
    });
